<template>
  <v-data-table
    :headers="headers"
    :items="desserts"
    :search="search"
    sort-by="fecha"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Bandeja de entrada</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="800px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col>
                    <h5> Remitente : {{remitente}}</h5>
                  </v-col>
                  <v-col>
                    <h5> Fecha : {{ fecha}}</h5>  
                  </v-col>
                </v-row>
               <v-row>
                  <v-col>
                    <h5> Asunto : {{asunto}}</h5>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <h5> Mensaje : {{mensaje}}</h5>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <h5> Adjuntos : </h5>
                  </v-col>
                </v-row>
                 <v-row>
                  <v-col>
                     <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title ><v-icon
                        small
                      >
                       mdi-file-pdf
                      </v-icon>Factura_2150 <v-icon
                        small
                        @click="Download(item)"
                      >
                       mdi-download
                      </v-icon></v-list-item-title>
                      
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title ><v-icon
                        small
                      >
                       mdi-file
                      </v-icon>Nota <v-icon
                        small
                        @click="Download(item)"
                      >
                       mdi-download
                      </v-icon></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                              <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title ><v-icon
                        small
                      >
                       mdi-file-pdf
                      </v-icon>factura_alimentos <v-icon
                        small
                        @click="Download(item)"
                      >
                       mdi-download
                      </v-icon></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cerrar</v-btn>
              <v-btn color="blue darken-1" text @click="save">Descargar adjuntos</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
         <v-dialog v-model="dialog2" max-width="800px">
          <v-card>
            <v-card-title>
              <span class="headline">Agregar documento</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col>
                    <h5> Remitente : {{remitente}}</h5>
                  </v-col>
                  <v-col>
                    <h5> Fecha : {{ fecha}}</h5>  
                  </v-col>
                </v-row>
               <v-row>
                  <v-col>
                    <h5> Asunto : {{asunto}}</h5>
                  </v-col>
                </v-row>
                  <v-row>
                  <v-col>
                    <v-select
                v-model="select"
                :items="gastos"
                label="Concepto"
                data-vv-name="select"
                @change="postPost()"
                required></v-select>
                  </v-col>
                </v-row>
                   <v-row>
                  <v-col>
                 <v-select
                v-model="select"
                :items="cuentas"
                label="Cuenta"
                data-vv-name="select"
                required></v-select>
                  </v-col>
                </v-row>
                                   <v-row>
                  <v-col>
               <v-textarea
                  counter
                  label="Descripción"
                  :rules="rules"
                  :value="value"
                ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close2">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="save">Agregar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar><v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="visualizar(item)"
      >
        mdi-eye
      </v-icon>
      <v-icon
        small
        @click="AddComprobacion(item)"
      >
       mdi-note-plus
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
    <template v-slot:item.Estado="{ item }"   @click="visualizar(item)">
      <v-chip :color="getColor(item.Estado)" dark  @click="visualizar(item)">  <v-icon small class="iconemail">
       {{ getIcon(item.Estado) }}
      </v-icon> {{ item.Estado }}</v-chip>
    </template>
  </v-data-table>
</template>
<script>
import axios from "axios";
import router from '../router/index.js'

  export default {
    data: () => ({
      dialog: false,
      dialog2: false,
      search: '',
      headers: [
        {
          text: 'Remitente',
          align: 'left',
          sortable: true,
          value: 'concepto',
        },
        { text: 'Estado', value: 'Estado' },
        { text: 'Asunto', value: 'Tipo' },
        { text: 'Fecha', value: 'importe' },
        { text: 'Acciones', value: 'action', sortable: false },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        concepto: '',
        Estado: '',
        Tipo: '',
        Importe: '',
      },
      defaultItem: {
        concepto: '',
        Estado: '',
        Tipo: '',
        Importe: '',
      },
      tipo: ['Comprobacion','Anticipo'] ,
      estado: ['En proceso','Autorizada','Cancelada'],
      remitente: '',
      asunto: '',
      fecha: '',
      mensaje: '',
      gastos: ['Hotel',
              'Alimentos',
              'Renta de vehículo',
              'Peaje',
              'Gasolina',
              'Avión',
              'Autobús',
              'Taxi',
              'Estacionamiento',
              'Despensa',
              'Agua de beber',
              'Papelería',
              'Limpieza',
              'Mensajería',
              'Regalos a clientes',
              'Consumo de alimentos locales',
              'Mantenimiento auto',
              'Gastos de celulares'],
      'cuentas' :['625110-VIAJES Y GASTOS REEMBOLSADOS',
                  '625720-GASTOS NO DEDUCIBLES',
                  '606110-GASOLINA',
                  '606111-GASOLINA ND',
                  '625120-REEMBOLSO Y GASTOS VEHICULOS',
                  '613201-GASTOS COMUNES',
                  '613202-GASTOS COMUNES ND',
                  '606400-GASTOS DE LIBRERIA',
                  '606300-GASTOS DE LIMPIEZA',
                  '626400-MESSENGER SERVICES',
                  '623400-CUSTOMER GIFTS',
                  '625700-MEALS & ENTERTAINMENT',
                  '615610-MANTENIMIENTO VEHICULO',
                  '615600-MANTENIM DE MAT INFORMATICO',
                  '613620-ALQUILER TRANSPORTES',
                  '613621-ALQUILER TRANSPORTES ND',]
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Correo'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
       dialog2 (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.desserts = [
          {
            concepto: 'Sergio Dávila Najera',
            Estado: 'No leído',
            Tipo: 'Comprobación del viaje a Guadalara semana 20 al 24 Enero 2020',
            importe: '27-01-2020',
            mensaje: 'Buenas tardes adjunto la comprobación del viaje realizado la semana pasada a Guadalajara,quedo pendiente de cualquier comentario.',
          },
         {
             concepto: 'Benjamín Hernández Martínez',
            Estado: 'No leído',
            Tipo: 'Comprobación del viaje a San Luis Potosí',
            importe: '17-01-2020',
            mensaje: 'Buenas tardes adjunto la comprobación del viaje realizado la semana pasada a Guadalajara,quedo pendiente de cualquier comentario.',

          },
          {
            concepto: 'Carmelo Tadeo Acevedo Ortiz',
            Estado: 'Leído',
            Tipo: 'Comprobación del viaje a CDMX',
            importe: '12-01-2020',
            mensaje: 'Buenas tardes adjunto la comprobación del viaje realizado la semana pasada a Guadalajara,quedo pendiente de cualquier comentario.',

          },
          {
             concepto: 'Miguel Pérez Hurtado',
            Estado: 'Leído',
            Tipo: 'Gastos de comida',
            importe: '8-01-2020',
             mensaje: 'Buenas tardes adjunto la comprobación del viaje realizado la semana pasada a Guadalajara,quedo pendiente de cualquier comentario.',

          },
          {
             concepto: 'Jose Armando Palacios Rodríguez',
            Estado: 'Leído',
            Tipo: 'Gastos de hospedaje',
            importe: '10-01-2020',
           mensaje: 'Buenas tardes adjunto la comprobación del viaje realizado la semana pasada a Guadalajara,quedo pendiente de cualquier comentario.',

          },
                  {
            concepto: 'Carlos Martínez Insunza',
            Estado: 'Leído',
            Tipo: 'Comprobación del viaje a San Luis Potosí semana 13 al 17 Enero 2020',
            importe: '9-01-2020',
             mensaje: 'Buenas tardes adjunto la comprobación del viaje realizado la semana pasada a Guadalajara,quedo pendiente de cualquier comentario.',

          },
          {
            concepto: 'Araceli Jazmín miguel Butanda',
            Estado: 'Leído',
            Tipo: 'Comprobación de anticipo para viaje a CDMX',
            importe: '7-01-2020',
            mensaje: 'Buenas tardes adjunto la comprobación del viaje realizado la semana pasada a Guadalajara,quedo pendiente de cualquier comentario.',

          },
          {
            concepto: 'Mildred Alvarez Maya',
            Estado: 'Leído',
            Tipo: 'Documentos de comprobantes de anticipo viaje a Guadalajara',
            importe: '6-01-2020',
            mensaje: 'Buenas tardes adjunto la comprobación del viaje realizado la semana pasada a Guadalajara,quedo pendiente de cualquier comentario.',

          },
          {
            concepto: 'Sharon Marlen Serrano Bolanos',
            Estado: 'Leído',
            Tipo: 'Comprobantes de gastos de Guadalajara semana 23 al 27 de diciembre 2019',
            importe: '30-12-2019',
           mensaje: 'Buenas tardes adjunto la comprobación del viaje realizado la semana pasada a Guadalajara,quedo pendiente de cualquier comentario.',

          },
          {
            concepto: 'Karla Elizabeth Resendíz Martínez',
            Estado: 'Leído',
            Tipo: 'Comprobantes de anticipo',
            importe: '18-12-2019',
           mensaje: 'Buenas tardes adjunto la comprobación del viaje realizado la semana pasada a Guadalajara,quedo pendiente de cualquier comentario.',

          }
        ]
      },
      getColor (Estado) {
        if (Estado=='No leído') return 'orange'
        else if (Estado=='En proceso') return 'red'
        else return 'green'
      },
       getIcon (Estado) {
        if (Estado=='No leído') return 'mdi-email'
        else if (Estado=='En proceso') return 'mdi-email'
        else return ' mdi-email-open'
      },
      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      AddComprobacion (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog2 = true
      },
      deleteItem (item) {
        const index = this.desserts.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
      },
      visualizar (item) {
          this.remitente=item.concepto;
          this.asunto=item.Tipo;
          this.concepto=item.concepto;
          this.fecha=item.importe;
          this.mensaje=item.mensaje;
          this.editedIndex = this.desserts.indexOf(item)
          this.editedItem = Object.assign({}, item)
          this.dialog = true
      },
      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      close2 () {
        this.dialog2 = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem)
        } else {
          this.desserts.push(this.editedItem)
        }
        this.close()
      },
    },
    mounted() {
      //Config for axios
      axios.defaults.headers.common['access-token'] = this.$store.state.token;

      axios.interceptors.response.use(function (response){
          if (response.data.message == 'Token inválida') {
              router.push({name: 'login', params: {errorToken: 'true'}});
          }else{
              return response;
          }
      });
      //End config for axios  
      }
  }
</script>
<style scoped>
.iconemail{
   padding-right:6px;
}
.headline{

}
</style>